import React, { useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import SvgQuestionMarkIcon from '../svg/QuestionMarkIcon';
import SvgXIcon from '../svg/XIcon';
import InlineHelpText from './InlineHelpText';


function HelpIcon(props) {
  const { toggled, styles, onClick } = props;
  return (
    <React.Fragment>
      {toggled ? (
        <SvgXIcon
          data-test="x-icon"
          onClick={onClick}
          className={'help-icon help-icon--toggled ' + styles}
        />
      ) : (
        <SvgQuestionMarkIcon
          data-test="question-icon"
          onClick={onClick}
          className={'help-icon ' + styles}
        />
      )}
    </React.Fragment>
  );
}

export const HelpWithIcon = ({text, helpId}) => {
  const intl = useIntl();
  const [showHelpText, setShowHelpText] = useState(false);
  const helpTextRef = useRef();

  // Only call formatMessage if helpId is a valid non-empty string
  let helpTextFormatted = text || '';
  
  try {
    if (helpId && typeof helpId === 'string' && helpId.length > 0) {
      helpTextFormatted = intl.formatMessage({
        id: helpId,
        defaultMessage: text || 'Help text',
        description: text || 'Help text',
      });
    }
  } catch (error) {
    // If formatMessage fails, fall back to text
    console.warn('Error formatting help text:', error);
    helpTextFormatted = text || '';
  }

  function toggleHelpText(value) {
    setShowHelpText(value);
  }

  return (
    <>
      <HelpIcon 
        onClick={() => helpTextRef.current.toggleHelpText()}
        toggled={showHelpText} 
        styles="margin-left-5"
      />
      <InlineHelpText
        ref={helpTextRef}
        toggleFunction={toggleHelpText}
        message={helpTextFormatted}
      />
    </>
  )
}

export default HelpIcon;
